const initialState={
    phones:[],
    loading:true,
    count_cart: 0,
    total_price: 0,
    cart:[],
    error:null,
};

const findCartItem=(id , state)=>{
    let ind=state.cart.findIndex((item)=>id===item.id);
    let cartItem=state.cart[ind];
    return {
        ind,cartItem
    }
}
const updateCount=(id , state , operation)=>{

    let {ind  , cartItem}=findCartItem(id , state);

    let {count , price}=cartItem;

    let newProps={
        count: operation === 'plus' ? ++count : --count,
    }
    let updateItem=Object.assign(cartItem , newProps);

    // let total_price=state.total_price-price;
    let total_price=operation === 'plus' ? state.total_price+price : state.total_price-price;

    return {
        ...state,
        total_price,
        cart:[
            ...state.cart.slice(0 , ind),
            updateItem,
            ...state.cart.slice(ind+1),
        ]
    }
}
const deleteCartItem=(id , state)=>{

    let {ind  , cartItem}=findCartItem(id , state);
    
    let total_price=state.total_price-(cartItem.count*cartItem.price);
    let count_cart=state.count_cart-cartItem.count;
    return {
        ...state,
        total_price,
        count_cart,
        cart:[
            ...state.cart.slice(0 , ind),
            ...state.cart.slice(ind+1),
        ]
    }
}



const reducer=(state=initialState , action)=>{
    
        switch(action.type){
            case 'loading' : {
                return {
                    ...state,
                    error:null,
                    loading:action.loading,
                }
            }
            case 'phone_loaded' : {
                return {
                    ...state,
                    error:null,
                    phones: action.payload,
                    loading:false,
                }
            }
            case 'error':{
                return {
                    ...state,
                    loading:false,
                    error: action.error,
                }
            }
 
            case 'add_product' : {

                let {product}=action;
                let {price , count , id , name}=product;
            
                let count_cart=state.count_cart+count;
                let total_price=state.total_price+(price*count);


                let {ind  , cartItem}=findCartItem(id , state);

                let newItem;
                
                if(cartItem){

                    let recount=count+cartItem.count;
                    // let reprice=(price*count)+cartItem.price;
                    let reprice=cartItem.price;

                    newItem={
                        ...cartItem,
                        count:recount,
                        price:reprice,
                    }
                }
                else{
                    newItem={
                        name,
                        count,
                        price,
                        id,
                    }
                }

                if(ind<0){
                    return{
                        ...state,
                        count_cart,
                        total_price,
                        cart:[
                            ...state.cart , newItem
                        ]
    
                    }
                }
                else{
                    return{
                        ...state,
                        count_cart,
                        total_price,
                        cart:[
                            ...state.cart.slice(0 , ind),
                            newItem,
                            ...state.cart.slice(ind+1),
                        ]
    
                    }
                }
                
                
    
                

            } 

            case 'minus_cart':{
                let {id}=action;
                return updateCount(id , state , 'minus');
            }

            case 'plus_cart':{
                let {id}=action;
                return updateCount(id , state , 'plus');
            }

            case 'delete_cart':{
                return deleteCartItem(action.id , state);
            }
            default : return state;
        }

    
}

export {reducer};